export default __webpack_public_path__ + "static/media/search.e9d0e5cd.svg";